import React from 'react';

import Button from '../../../components/ui/Button';

const BulkActionsBar = ({ selectedCount, onPublish, onUnpublish, onArchive, onDelete, onClearSelection }) => {
  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-4 md:bottom-6 left-1/2 -translate-x-1/2 z-50 w-[calc(100%-2rem)] md:w-auto">
      <div className="bg-card border border-border rounded-lg shadow-lg p-3 md:p-4">
        <div className="flex flex-col md:flex-row items-center gap-3 md:gap-4">
          <div className="flex items-center gap-2 text-sm font-medium text-foreground">
            <div className="w-8 h-8 rounded-full bg-primary/10 text-primary flex items-center justify-center font-semibold">
              {selectedCount}
            </div>
            <span className="whitespace-nowrap">{selectedCount} page{selectedCount > 1 ? 's' : ''} selected</span>
          </div>

          <div className="h-px md:h-6 w-full md:w-px bg-border" />

          <div className="flex flex-wrap items-center gap-2 justify-center">
            <Button
              variant="outline"
              size="sm"
              iconName="Upload"
              iconPosition="left"
              onClick={onPublish}
            >
              Publish
            </Button>

            <Button
              variant="outline"
              size="sm"
              iconName="Download"
              iconPosition="left"
              onClick={onUnpublish}
            >
              Unpublish
            </Button>

            <Button
              variant="outline"
              size="sm"
              iconName="Archive"
              iconPosition="left"
              onClick={onArchive}
            >
              Archive
            </Button>

            <Button
              variant="destructive"
              size="sm"
              iconName="Trash2"
              iconPosition="left"
              onClick={onDelete}
            >
              Delete
            </Button>

            <div className="h-6 w-px bg-border hidden md:block" />

            <Button
              variant="ghost"
              size="sm"
              iconName="X"
              onClick={onClearSelection}
            >
              Clear
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkActionsBar;